import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { ENotificationReportContextService, ENotificationReportContextFactory } from '@app/core/services/context/factory';
import { ENotification } from '@app/core/model/e-Notification';
import { ShellService } from '@mynexus/mfe-core';
import { Table } from 'primeng/table';
import { FilterService, SelectItem } from 'primeng/api';
import { DocumentsService } from '@app/core/services';
import { AppliedFilter } from '@app/core/model/appliedFilter.model';

@Component({
    selector: 'mnc-document-e-notification',
    templateUrl: './document-e-notification.component.html',
    styleUrls: ['./document-e-notification.component.scss'],
    providers: [
        {
            provide: ENotificationReportContextService,
            useFactory: ENotificationReportContextFactory,
            deps: [HttpClient, ShellService]
        }
    ],
    standalone: false
})

export class DocumentENotificationComponent implements OnChanges {
  @Input() authorizationByProductId: string;
  @Input() tenantId!: string;
  @Input() eNotifications: ENotification[];
  filteredNotifications : ENotification[] = null ;


 // Filters
 appliedFilters: {[key: string]: AppliedFilter } = {
    lineNumber: {
      matchMode: '',
      value: '',
    },
    createdOn: {
      matchMode: '',
      value: '',
    },
    notificationEvent: {
      matchMode: '',
      value: '',
    }
  };

notificationEvent: SelectItem[] = []
lineNumbers: SelectItem[] = [];
isLoading = true;
@ViewChild('dt', { static: false }) dataTable!: Table;

  constructor(
    private documentsService: DocumentsService,
    private ref: ChangeDetectorRef,
    private filterService: FilterService,
  ) {
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['eNotifications']) {
      this.OnInit();
    }
  }

  OnInit(): void {
    if (this.eNotifications !== null && this.eNotifications?.length > 0) {
      this.eNotifications.forEach(x => x.notificationEvent = this.getNotificationEvent(x.notificationEvent) )
      this.filteredNotifications = this.eNotifications;
        this.isLoading = false;
         this.notificationEvent = this.documentsService.getUniqueFilterOptions(this.eNotifications.map(x => x.notificationEvent));
        if (this.filteredNotifications && this.filteredNotifications.length > 0) {
          this.filteredNotifications.forEach(it => {
            this.lineNumbers.push({ label: it.lineNumber.toString(), value: it.lineNumber })
          });
        } else {
          this.lineNumbers = [];
        }
        this.ref.markForCheck();
    }
  }

  filterTable(value: any, criteria: string, matchMode: string) {
      this.dataTable.first = 0;
      switch(matchMode) {
        case 'customDate':
          if (value) {
            if (value[0] && value[1]) {
              this.clearCustomFilter(criteria);
              const currentResults = this.filteredNotifications;
              this.filteredNotifications = this.filterService.filter(currentResults, [criteria], value, 'customDate');
            }
          } else {
            this.clearCustomFilter(criteria);
          }
        break;
        default:
          this.dataTable.filter(value, criteria, matchMode);
        break;
      }
      this.appliedFilters[criteria].matchMode = matchMode;
      this.appliedFilters[criteria].value = value;
  }

 clearCustomFilter(criteria: string): void {
      this.filteredNotifications = this.eNotifications;
      this.appliedFilters[criteria].value = null;
      for (const filter in this.appliedFilters) {
        if (filter !== criteria) {
          const appliedFilter = this.appliedFilters[filter];
          if (appliedFilter.value && appliedFilter.matchMode) {
            this.dataTable.filter(appliedFilter.value, filter, appliedFilter.matchMode)
          }
        }
      }
  }

  getNotificationEvent(notificationEvent: string): string {
      if(notificationEvent && notificationEvent !== '') {
            return notificationEvent.substring(0,5) + ' ' + notificationEvent.substring(5, notificationEvent.length);
      } else {
            return '' ;
      }
  }
}
